<template>
  <div class="container">
    <a-layout-content v-show="getSoyonara()">
      <div class="mb-24">
        <template v-if="fullBreadcrumbs">
          <T1BreadcrumbsPlaceholder v-if="!hotelBreadcrumbsReady" />
          <T1HotelBreadcrumbs
            v-show="hotelBreadcrumbsReady"
            v-if="getHlocid()"
            :locid="getHlocid()"
            :hotel="getHotel()"
          />
        </template>
        <template v-else>
          <T1BreadcrumbsPlaceholder v-if="!breadcrumbsReady" />
          <T1Breadcrumbs
            v-show="breadcrumbsReady"
            :homeLink="true"
            :items="getBreadcrumbs()"
          />
        </template>
      </div>
      <T1HotelCarousel :hlocid="hlocid" />
      <T1Rezerwacja />
      <T1RODO />
    </a-layout-content>
    <a-layout-content v-show="!getSoyonara()">
      <T1HotelBrakOfert />
      <!-- <h3 class="font-20 mb-24 mb-md-12">
        Oferty w okolicy
      </h3>
      <T1TopOffers v-if="hlocid" :locid.sync="hlocid" />
      <T1ForecastWidget :wname="locName" :hlocid.sync="hlocid" v-if="hlocid" /> -->
    </a-layout-content>
  </div>
</template>

<script>
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1BreadcrumbsPlaceholder from "./T1Placeholders/T1BreadcrumbsPlaceholder";
import T1HotelCarousel from "./T1HotelCarousel";
import T1Rezerwacja from "./T1Rezerwacja";
import T1RODO from "./T1RODO";
// import T1TopOffers from "./T1TopOffers";
import T1HotelBrakOfert from "./T1HotelBrakOfert";
// import T1ForecastWidget from "./T1PogodaKlimat/T1ForecastWidget";
import T1HotelBreadcrumbs from "./T1Breadcrumbs/T1HotelBreadcrumbs";
import * as CONFIG from "./config.js";

export default {
  name: "hotel-content",
  data: () => ({
    offerType: "",
    offerName: "",
    region: "",
    city: "",
    hlocid: "",
    offerObjectName: "",
    soyonara: "alive",
    locName: "",
    breadcrumbsReady: false,
    hotelBreadcrumbsReady: false,
    fullBreadcrumbs: false
  }),
  methods: {
    addExtraItems() {
      let extraItems = [];
      let holidaysContextUrl = CONFIG.defaultContext;

      extraItems.push({
        name: "Lista ofert",
        link: holidaysContextUrl + "/oferty.xml"
      });
      return extraItems;
    },
    getBreadcrumbs() {
      let crumbsArr = [];

      if (this.offerType != "R") {
        if (this.region != "") {
          crumbsArr.push({ name: this.region, link: "" });
        }
        if (this.city != "") {
          crumbsArr.push({ name: this.city, link: "" });
        }
      } else {
        crumbsArr.push({ name: "Wycieczki objazdowe", link: "" });
        if (this.offerObjectName != "") {
          crumbsArr.push({ name: this.offerObjectName, link: "" });
        }
      }
      return crumbsArr;
    },
    getGeoSciezka() {
      return this.geosciezka;
    },
    getHlocid() {
      return this.hlocid;
    },
    getHotel() {
      return this.offerObjectName;
    },
    getSoyonara() {
      if (this.soyonara === "sepuku") {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    let that = this;
    this.$root.$on("update:offerType", val1 => {
      that.offerType = val1;
    });
    this.$root.$on("update:region", val1 => {
      that.region = val1;
    });
    this.$root.$on("update:city", val1 => {
      that.city = val1;
    });
    this.$root.$on("update:hlocid", val1 => {
      that.hlocid = val1;
    });
    this.$root.$on("update:ofrObjName", val1 => {
      that.offerObjectName = val1;
    });
    this.$root.$on("update:soyonara", val1 => {
      that.soyonara = val1;
    });
    this.$root.$on("update:hotelBreadcrumbsReady", val1 => {
      that.hotelBreadcrumbsReady = val1;
    });
    this.$root.$on("update:breadcrumbsReady", val1 => {
      setTimeout(() => {
        that.breadcrumbsReady = val1;
      }, 500);
    });
  },
  updated() {
    this.$nextTick(() => {
      if (this.hlocid) {
        this.fullBreadcrumbs = true;
      }
    });
  },
  components: {
    T1Breadcrumbs,
    T1HotelCarousel,
    T1Rezerwacja,
    T1RODO,
    // T1TopOffers,
    T1HotelBrakOfert,
    // T1ForecastWidget,
    T1BreadcrumbsPlaceholder,
    T1HotelBreadcrumbs
  }
};
</script>
